import { useState, useEffect } from 'react';
import { IonPage, IonContent } from '@ionic/react';
import { useLocation } from 'react-router-dom';
import { getClientById } from '../services/clientService';
import { ClientAuditReport } from '../components/clients/ClientAuditReport';
import { useBreadcrumbStore } from '../store/useBreadcrumbStore';

export default function ClientAuditPage() {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const clientId = params.get('clientId') || undefined;
  const [clientName, setClientName] = useState('');
  const setBreadcrumb = useBreadcrumbStore((s) => s.set);

  useEffect(() => {
    if (location.pathname !== '/client-audit' || !clientId) return;
    getClientById(clientId).then((client) => {
      const name = client.name || clientId;
      setClientName(name);
      setBreadcrumb([
        { label: 'Clients', path: '/clients' },
        { label: name, path: `/client-detail?clientId=${clientId}` },
        { label: 'Client Audit' },
      ]);
    });
  }, [location.pathname, clientId, setBreadcrumb]);

  if (!clientId) return null;

  return (
    <IonPage>
      <IonContent>
        <div className="p-4 sm:p-6 lg:p-8">
          <ClientAuditReport clientId={clientId} clientName={clientName} />
        </div>
      </IonContent>
    </IonPage>
  );
}
